const BASE_URL = 'https://baseutilities-production.up.railway.app';
//const BASE_URL = 'http://localhost:3001';
export const sendEmail = async(formData) => {
    try {
        const response = await fetch(`${BASE_URL}/api/send-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });

        await response.json();

        if (response.ok) {
            console.log('success');
        } else {
            console.error(response.error);
        }
    } catch (err) {
      console.error(err);
    }
}